var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-deals-page"},[_c('DealsTable',{attrs:{"title":_vm.$t('MENU.ASIDE.DEALS_LIST')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }